(function () {
  function AccordionPopup() {
    this.triggers = document.querySelectorAll('.accordion__content-head button');

    if (!this.triggers.length) return;

    this.accordionDisc = document.querySelectorAll('.accordion__disclosure');

    this.bindEvents();
  }

  function MailVariables(){

    this.emailTrigger = document.getElementById('buttonMail');


    if (!this.emailTrigger) return;

    let btnHref = this.emailTrigger.getAttribute('href');
    const productName = document.querySelector('.product .product-title');

    if(productName){
      this.emailTrigger.href = btnHref.replace('__PRODUCTNAME__', encodeURIComponent(productName.innerText));
    }
    
  }

  function GsapAnimation(){
 
    if(typeof gsap === 'undefined'){
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    let mm = gsap.matchMedia();

    mm.add("(min-width: 992px)", () => {
      ScrollTrigger.create({
        trigger: '#shopify-section-template--27188539425032__image_with_text_overlay_MnVmVJ',
        start: "top top",
        endTrigger: "#shopify-section-template--27188539425032__zest_big_text_xqhw3c",
        end: "top top",
        pin: true,
        pinSpacing: false,
      });
    });

  }

  AccordionPopup.prototype.bindEvents = function () {
    var self = this;

    var _accordionDisc = this.accordionDisc;

    _accordionDisc.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {

        _accordionDisc.forEach(function (item) {
  
          if(item.getAttribute('aria-expanded') === 'true'){
            if(item !== trigger){
              item.setAttribute('aria-expanded', false);
              item.removeAttribute('open');
            }
          }
        });

      });
    });

    this.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        this.closest('.accordion').querySelector('summary').click();
      });
    });
  };



  document.addEventListener('DOMContentLoaded', function () {
    new AccordionPopup();
    new MailVariables();
    new GsapAnimation();
  });
})();